import * as React from "react";
import { Button, Spin, Timeline, Tooltip } from "antd";
import { viewDateTimeUtc } from "src/common/formats";
import { TimelineItemProps } from "antd/lib";
import { EditOutlined } from "@ant-design/icons";
import { ZAuditEvent } from "../ZEntityAudit";
import styles from "./EntityAuditList.module.less";

interface PropsEntityAuditList {
  list: ZAuditEvent[];
  onAuditEvent(event: ZAuditEvent): void;
  loading: boolean;
}

export const EntityAuditList: React.FC<PropsEntityAuditList> = (props) => {
  const { list, onAuditEvent, loading } = props;
  const onItem = (item: ZAuditEvent) => {
    onAuditEvent(item);
  };
  const items: TimelineItemProps[] = React.useMemo(
    () =>
      list.map((item) => ({
        children: (
          <div key={item.transactionId} className={styles.item}>
            <Tooltip
              title={`Переход на версию ${viewDateTimeUtc(item.timestamp)}}`}
            >
              <Button
                type="text"
                className={styles.time}
                onClick={() => onItem(item)}
              >
                Версия от {viewDateTimeUtc(item.timestamp)}
              </Button>
            </Tooltip>
            <div className={styles.fio}>
              <EditOutlined />
              <span>{item.fio}</span>
            </div>
          </div>
        ),
      })),
    [list],
  );
  return (
    <div className={styles.box}>
      <Spin spinning={loading}>
        <div className={styles.content}>
          <Timeline items={items} />
        </div>
      </Spin>
    </div>
  );
};
